(function($){
    
    $('.v2-tabs ul li').first().addClass('v2-active');
    $('.v2-tabs-content').first().show();

    $(document).on('click', '.v2-tabs li', function() {
      var id = $(this).data('id');
      $('.v2-tabs-content').hide();
      $('.v2-tabs ul li').removeClass('v2-active');
      $(this).addClass('v2-active');
      console.log( id );
      $('#'+id).show();
    });

     
    $(document).on('click', '.help_txt', function(){
      $(this).hide();
      $('.minorder_txt').slideDown();
    });

    $('li.sidebar-active').children('ul').show();   
    $('li.child-active').parent('ul').show();   
  
  	$(document).find('.site-navigation a').each(function() {
        var hotdeals = "hotdealsofthemonth";
        var elemText = $(this).text().toLowerCase().replace(/\s/g, '');
        if( hotdeals == elemText ) {
            $(this).addClass("hotdeals");
        }
    });
  
  $(document).on('click', '.search-collpase', function(){
        $('.live-search').slideToggle();
  });
  
  
  
  })(jQuery);

$('.category-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

$('.offer-slider').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

$('.product-slider').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

$('.product-slider').on('setPosition', function () {
$(this).find('.slide-item').height('auto');
var slickTrack = $(this).find('.slick-track');
var slickTrackHeight = $(slickTrack).height();
$(this).find('.slide-item').css('height', slickTrackHeight + 'px');
});
$(document).ready(function(){  
  $('.show-more').on('click', function(e){
    e.preventDefault();
    var btn = $(this).toggleClass('active');
    if(btn.hasClass('active')) {
      btn.parent().find('.show-more-content').show();
      btn[0].innerHTML = 'Read Less'
    }
    else{
      btn.parent().find('.show-more-content').hide();
      btn[0].innerHTML = 'Read More'
    }
  })
});